var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.431,
    height: 9.473,
    viewBox: "0 0 9.431 9.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "clear-all-svgrepo-com",
    d: "M8.313,0a.592.592,0,0,1,.419,1.011l-.5.5a4.737,4.737,0,1,1-8.155,3.9A.592.592,0,0,1,1.25,5.245a3.553,3.553,0,1,0,6.145-2.9l-.434.434A.592.592,0,0,1,5.95,2.363V0ZM.917,2.368a.592.592,0,1,1-.592.592A.592.592,0,0,1,.917,2.368ZM2.25.74a.592.592,0,1,1-.592.592A.592.592,0,0,1,2.25.74ZM4.174,0a.592.592,0,1,1-.592.592A.592.592,0,0,1,4.174,0Z",
    transform: "translate(-0.072)",
    fill: "#00aec7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.f99fbace348b82eae26fe8e7c5e29c89.svg";
export { ForwardRef as ReactComponent };